import { call, put, takeEvery } from "redux-saga/effects";
import { eKeHoachNhomLopActionIds, IKeHoachNhomLopActionTypes } from "../../action-types/ke-hoach/IKeHoachNhomLopAction";
import { keHoachNhomLopApi } from "../../../api/ke-hoach/keHoachNhomLopApi";
import { rootActions } from "../../actions/rootActions";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachNhomLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopSelectRequest";
import { IKeHoachNhomLopSysRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopSysRequest";
import { IKeHoachNhomLop } from "../../../model/respone/ke-hoach/IKeHoachNhomLop";
import { IKeHoachNhomLopTachLopRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopTachLopRequest";

export function* keHoachNhomLopSaga(): any {
    yield takeEvery(eKeHoachNhomLopActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachNhomLopActionIds.SYS_FROM_KE_HOACH_MON_START, sysFromKeHoachMonWorker);
    yield takeEvery(eKeHoachNhomLopActionIds.UPDATE_START, updateWorker);
    yield takeEvery(eKeHoachNhomLopActionIds.TACH_LOPS_START, tachLopsWorker);
    yield takeEvery(eKeHoachNhomLopActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IKeHoachNhomLopActionTypes): any {
    const res: IBaseRespone = yield call(keHoachNhomLopApi.Select, action.payload as IKeHoachNhomLopSelectRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachNhomLop.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachNhomLop.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* sysFromKeHoachMonWorker(action: IKeHoachNhomLopActionTypes): any {
    const res: IBaseRespone = yield call(keHoachNhomLopApi.SysFromKeHoachMon, action.payload as IKeHoachNhomLopSysRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachNhomLop.SYS_FROM_KE_HOACH_MON_SUCCESS(undefined));
    } else {
        yield put(rootActions.keHoach.keHoachNhomLop.SYS_FROM_KE_HOACH_MON_ERROR(res.message ?? "Có lỗi"));
    }
}

function* updateWorker(action: IKeHoachNhomLopActionTypes): any {
    const res: IBaseRespone = yield call(keHoachNhomLopApi.Update, action.payload as IKeHoachNhomLop);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachNhomLop.UPDATE_SUCCESS(res.data));
    } else {
        yield put(rootActions.keHoach.keHoachNhomLop.UPDATE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* tachLopsWorker(action: IKeHoachNhomLopActionTypes): any {
    const res: IBaseRespone = yield call(keHoachNhomLopApi.TachLops, action.payload as IKeHoachNhomLopTachLopRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachNhomLop.TACH_LOPS_SUCCESS(undefined));
    } else {
        yield put(rootActions.keHoach.keHoachNhomLop.TACH_LOPS_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IKeHoachNhomLopActionTypes): any {
    const ids = action.payload as number[];
    const res: IBaseRespone = yield call(keHoachNhomLopApi.Deletes, { ids });
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachNhomLop.DELETE_SUCCESS(undefined));
    } else {
        yield put(rootActions.keHoach.keHoachNhomLop.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}